<template>
  <div style="min-width:1200px">
    <el-container>
      <el-header>
        <topnav></topnav>
      </el-header>
      <el-main><router-view v-if="routerAlive"></router-view></el-main>
      <el-footer><footernav></footernav></el-footer>
    </el-container>
    <div class="fixedRightNav">
      <div class="rightNav">
        <img src="../assets/img/ai_agent.png" class="ai_agent_icon" v-if="this.userInfo.mallUser.username" @click="goAiagent()">
        <div class="rightButton backTop" @click="backTop">
          <el-image
          style="width: 20px; height: 20px"
          :src="`${$imageUrl}/pcImages/images/backTop.png`"
          fit="fill"></el-image>
        </div>
        <transition name="el-fade-in-linear">
          <el-popover
          placement="left-end"
          width="300"
          trigger="click"
          @show="refreshUser"
          >
            <div>
              <el-row :gutter="20" class="userNameBox">
                <el-col :span="9">
                  <el-image
                    class="userNameImg"
                    :src="userInfo.avatar ? userInfo.avatar : defaultlogo"
                    fit="fill"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </el-col>
                <el-col :span="14" class="userNameBoxText">
                  <p class="userName">用户：{{ userInfo.userName }}</p>
                  <p style="display:none;" class="level">等级：{{ userInfo.level || 0 }}</p>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row class="cartBox_footer">
                <el-col :span="12" class="userNameBoxBottom"
                  ><router-link to="/myInfomation"
                    >个人中心</router-link
                  ></el-col
                >
                <el-col :span="12" class="userNameBoxBottom"
                  ><router-link to="/myOrderRight"
                    >订单中心</router-link
                  ></el-col
                >
              </el-row>
            </div>

            <el-button slot="reference">
              <div class="rightButton" @click.stop="doSomething($event)" @click="gologin()" v-if="this.userInfo.mallUser.username ==null||''||undefined">
              <el-image
              style="width: 20px; height: 20px"
              :src="`${$imageUrl}/pcImages/images/userIcon.png`"
              fit="fill"></el-image>
            </div>
            <div class="rightButton" v-else>
              <el-image
              style="width: 20px; height: 20px"
              :src="`${$imageUrl}/pcImages/images/userIcon.png`"
              fit="fill"></el-image>
            </div>
            </el-button>
          </el-popover>
        </transition>
        <div class="interlayer"></div>
        <div class="rightButton shoppingCart" @click="openCartDrawer" >
            <el-image
            style="width: 20px; height: 20px"
            :src="`${$imageUrl}/pcImages/images/shopCardIcon.png`"
            fit="fill"></el-image>
            <i class="shopping-cart-num" v-if="list.length>0">{{ list.length }}</i>
        </div>
        <div class="interlayer" v-if="false"></div>
        <div class="rightButton shoppingCart" @click="openInquiry"  v-if="false">
            <el-image
            style="width: 20px; height: 20px"
            :src="`${$imageUrl}/pcImages/images/xunjialanIcon.png`"
            fit="fill"></el-image>
            <i class="shopping-cart-num" v-if="inquiryList.length>0">{{ inquiryList.length }}</i>
        </div>
        <!-- <div class="el-icon-view" @click="openFooterDrawer"></div> -->

        <!-- <transition name="el-fade-in-linear">
          <el-popover
            popper-class="nolikePopBox"
            placement="left-end"
            width="50"
            trigger="hover"
          >
            <div class="userPartPop">我看过的</div>
            <el-button slot="reference">
              <div class="el-icon-view" @click="openFooterDrawer"></div>
            </el-button>
          </el-popover>
        </transition>

        <transition name="el-fade-in-linear">
          <el-popover
            popper-class="nolikePopBox"
            placement="left-end"
            width="50"
            trigger="hover"
          >
            <div class="userPartPop">我收藏的</div>
            <el-button slot="reference">
              <div class="nolike" @click="$router.push('/goodsCollection')">
                <img :src="require('@/assets/img/noLIke.png')" alt="" />
              </div>
            </el-button>
          </el-popover>
        </transition>-->
        <!-- 隐藏消息入口 -->
         <!-- <div class="interlayer"></div>
       <div @click="gologin()" id="iminfo" v-show="!this.userInfo.mallUser.username" class="shoppingCart">
          <i class="el-icon-chat-dot-round" style="font-size:26px"></i>
          <p>消息</p>
        </div>
        <div @click="showIM()" id="iminfo" v-show="this.userInfo.mallUser.username" class="shoppingCart">
          <i class="el-icon-chat-dot-round" style="font-size:26px"></i>
          <p>消息</p>
        </div> -->

        <!-- <div class="userPart">
               <el-image style="cursor:pointer" :src="require('@/assets/img/user.png')" fit="fill">
                     <div slot="error" class="image-slot">
                       <i class="el-icon-picture-outline"></i>
                     </div>
               </el-image>
            </div> -->
      </div>
      <!-- 20220107暂时注销购物车弹窗 -->
      <!-- 购物车 开始 -->
      <!-- <el-drawer
        class="drawerCart"
        title="购物车"
        :modal="false"
        :visible.sync="drawer"
      >
        <p class="drawerCartTitle" slot="title">
          <i class="el-icon-shopping-cart-2"></i>
          <router-link class="gotoShopText" to="/shoppingcart"
            >购物车</router-link
          >
        </p>
        <div class="drawerCartItem" v-loading="loading">
          <div>
            <div class="cartTip">
              <el-row
                :gutter="20"
                class="cartBox"
                v-for="(item, index) in list"
                :key="index"
              >
                <el-col :span="5" v-if="item.cartSpecificationDetails!=null">
                  <el-image
                    class="cartgoodsPhotos"
                    @click="$router.push(`/goodsdetail?id=${item.id}`)"
                    :src="`${item.cartSpecificationDetails.image}`"
                    fit="fill"
                  >
                  </el-image>
                </el-col>
                <el-col :span="12" v-if="item.cartSpecificationDetails!=null"
                  ><div
                    @click="$router.push(`/goodsdetail?id=${item.id}`)"
                    class="cartHeight"
                    title=""
                  >
                    {{ item.name+'('+item.cartSpecificationDetails.attributeContent+')' }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div class="cartHeight">
                    {{ item.realprice }} * {{ item.number }}
                  </div></el-col
                >
              </el-row>
              <el-row class="cartBox_footer">
                <el-col :span="12"
                  ><div class="cartHeight_total">
                    <p class="totalNum">共 {{ totalNumber || 0 }} 件商品</p>
                    <p>总计： ￥{{ accountTotal.toFixed(2) || 0 }} </p>
                  </div></el-col
                >
                <el-col :span="12"
                  ><div class="cartHeight_cart">
                    <router-link to="/shoppingcart" style="color: white"
                      >去购物车结算</router-link
                    >
                  </div></el-col
                >
              </el-row>
            </div>
          </div> -->

          <!-- 购物车没有东西的时候 -->
          <!-- <div class="drawerCartItem_no" v-if="list.length == 0 ? true : false">
            <el-image
              style="cursor: pointer"
              :src="require('@/assets/img/noresult.png')"
              fit="fill"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <p>您的购物车里什么都没有哦</p>
            <router-link class="gotoShopText" to="/goodsList"
              >再去看看吧</router-link
            >
          </div>
        </div>
      </el-drawer> -->
      <!-- 购物车 结束 -->

      <!-- 我的足迹 开始-->
      <el-drawer
        class="drawerCart"
        title="购物车"
        :modal="false"
        :visible.sync="footerdrawer"
      >
        <p class="drawerCartTitle" slot="title">
          <i class="el-icon-view"></i>
          <router-link class="gotoShopText" to="/myFooter"
            >我的足迹</router-link
          >
        </p>
        <div class="drawerCartItem drawerFooterItem" v-loading="footloading">
          <div
            class="isdrawerFooterItem"
            v-for="(item, index) in footerlist"
            :key="index"
          >
            <div class="isdrawerFooterItemBg" v-if="item.commodity != null">
              <el-image
                class="goodsFooter"
                style="cursor: pointer"
                @click="$jumpUrl('/goodsdetail',item.commodity.id)"
                :src="`${item.commodity.photos}`"
                fit="fill"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="cartHeight">￥{{ item.commodity.realprice }}</div>
            </div>
          </div>

          <!-- 购物车没有东西的时候 -->
          <div
            class="drawerCartItem_no"
            v-if="footerlist.length == 0 ? true : false"
          >
            <el-image
              style="cursor: pointer"
              :src="require('@/assets/img/noresult.png')"
              fit="fill"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <p>暂无您的浏览记录</p>
            <router-link class="gotoShopText" to="/goodsList"
              >再去看看吧</router-link
            >
          </div>
        </div>
      </el-drawer>
      <!-- 我的足迹 结束-->
    </div>
    <!-- IM -->
    <el-dialog
      class="dialogIMBox"
      title="提示"
      :visible.sync="centerDialogVisible"
      :modal="b_modal"
      width="35%"
      :append-to-body="bodyflag"
      center
    >
      <span slot="title" class="dialog-footer"> </span>
      <div class="row1" id="content-main-1">
        <iframe
          id="myiframe"
          onload="setIframeHeight(this)"
          src="http://8.136.244.109:8080/center/IM/#/main"
          width="100%"
          height="100%"
          frameborder="0"
          seamless
          scrolling="no"
        ></iframe>
      </div>
    </el-dialog>

    <!-- Ai问答 开始-->
    <el-drawer
        class="drawerCart"
        title="Ai问答"
        size="100%"
        :modal="true"
        :visible.sync="footerdrawer"
        :append-to-body="true"
      >
      <aiagentBox @closeDrawer="closeDrawer"></aiagentBox>

    </el-drawer>
      <!-- Ai问答 结束-->
  </div>
</template>

<!--<script type="text/javascript" src="../../static/im/js/configIM.js"></script>-->
<script type="text/javascript" src="../assets/js/kuCity.js"></script>
<script>
// 导入组件
import {userDetails,wxLogin,getWxUserInfoByOpenId,uniteUserInfo} from '@/api/xunyou'
// import "../../static/im/js/configIM.js";
import topnav from "../components/topnav.vue";
import footernav from "../components/footernav.vue";
import aiagentBox from "../components/aiagentBox.vue";
import { shoppingCartlist, footprint_list,getdetaultlogo } from "@/api/xunyou";
import { mapState, mapMutations } from "vuex";
export default {
  inject:['reload'],  //注入依赖
  name: "index",
  provide() {
    //在父组件中创建属性
    return {
      routerRefresh: this.routerRefresh,
    };
  },
  data() {
    return {
      code: '',
      routerAlive: true,
      bodyflag: true,
      b_modal: false,
      footloading: false,
      footerdrawer: false,
      footerlist: [],
      showclass: "asideshow",
      showtype: false,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {
        mallUser: {},
      },
      drawer: false,
      loading: false,
      // accountTotal:0,
      // list:[],
      centerDialogVisible: false,
      defaultlogo:''
    };
  },
  computed: {
    ...mapState(["list", "accountTotal", "totalNumber","inquiryList"]),
  },
  // 注册组件
  components: {
    footernav,
    topnav,
    aiagentBox,
  },
  created() {

    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
  mounted() {
    if(this.$route.query.token){
      this.getUniteUserInfo(this.$route.query.token)
    }
    this.getdefaultlogo()
    console.log(this.userInfo);
    // console.log(this.userInfo)
     this.getuserDetails()
    // if(this.userInfo.mallUser.username!=null||this.userInfo.mallUser.username!="" ){
    //       this.getshoppingCartlist();
    // }
    if(this.userInfo.mallUser.muid){
      this.getfootList();
    }


    var url = window.location.href;
    if(url.indexOf('?code=')!=-1)
    {
      //回调成功获取一下openid，如果表中存在的，就直接登录，如果没有就跳转到绑定认后登录
      this.code=url.substring(url.indexOf('?code=')+6,url.indexOf("&state"));
    }
    if(this.code!=''){
      this.getWxLogin()
    }
      if(this.userInfo){
        window.scrollTo(1,2)
      }
    // this.IMUtil.init();
    // 	$('.li_dorpdown').hover(function() {
    // 	$('.dorpdown-layer').show();
    // });
    // $('.li_dorpdown').mouseleave(function() {
    // 	$('.dorpdown-layer').hide();
    // });
  // this.judgeScroll()
  // this.modifyImleft();
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    // this.$message({
    //   message: "登录成功",
    //   type: "success",
    // });
  },
  methods: {
    goAiagent(){
      this.footerdrawer = true
    },
    closeDrawer(){
      this.footerdrawer = false
    },
    //获取联合用户信息
    getUniteUserInfo(token){
      uniteUserInfo({token:token}).then(res=>{

        if(res.success){
          const mallUser = {
          avatar:res.data.avatar,
          muid:res.data.userId,
          nickname:res.data.userName,
          password:res.data.password,
          username:res.data.userName
        }
          if(res.data.mallUser == null){
          res.data.mallUser = mallUser
        }
          localStorage.setItem('userdata', JSON.stringify(res.data))
          this.reload();
          this.$router.push('/')
        }else{
          this.$message.error(res.errorMessage)
        }
      }).catch(err=>{
        this.$message.error(err.errorMessage)
      })
    },
     // 获取默认头像
     getdefaultlogo() {
          getdetaultlogo().then(res=>{
              if (res.code == 0) {
                  this.defaultlogo = res.rows[0].avatar
              }
          })
      },
    backTop(){
      window.scrollTo({
    top: 0,
    behavior: 'smooth',
    });
    },
    getButtonIm(){
      // document.getElementsByClassName('im-layernew').onclick()
      console.log(document.getElementsByClassName('im-layernew'))
    },
    //修改im位置
    modifyImleft(){
      setTimeout(() => {
      document.getElementById('im-layer2').style.left = document.documentElement.scrollWidth-62+'px'
      // console.log(oldletf)
        }, 500);


    },

    //加载页面滚动

    handleScroll() {
    window.pageYOffset=1
    // console.log(window.pageYOffset )
  },


    gologin(){
      if(this.userInfo.mallUser.username ==null||''||undefined){
        this.$router.push('/login');
      }

    },
    showIM(){
      var im =document.getElementById('im-layer1');

      im.style.display='block'
    },
    async getWxLogin(){
      // var secret = '68b1fbf5a35876ee70336536196f42d3'
      // var appid = 'wx736f41fbf5078a60'
      // window.location.href=`https://api.weixin.qq.com/sns/oauth2/access_token?appid=${appid}&secret=${secret}&code=${code}&grant_type=authorization_code`
      wxLogin({
        code:this.code
      }).then(async res=>{
        console.log("-----------------------");
         console.log(res);
          console.log("jianz");
          // res.unionid = 'oD4C25lijmnxqA5GaF3jX5XwiCyw'
         if(res.unionid!=undefined){
           res.unionid = await getWxUserInfoByOpenId({
            openid: res.unionid,
						source: 'h5'
          })
          .then(res1=>{
            // console.log(res1);
            if(res1.code == 0) {
              if(res1.data){
              // localStorage.setItem('userdata', JSON.stringify(res1.data))
              this.$store.commit('login',JSON.stringify(res1.data))
              this.$message.success('登录成功')
              // this.$router.push({ path: '/' })
              let endNum = window.location.href.indexOf('?code=')
              window.location.href = window.location.href.substring(0,endNum)
                    // window.location.reload();
            }else{
              this.$message.error('请绑定微信')
              this.$router.push('/wxBound?unionid='+res.unionid)
            }
            }else if (res1.code == 500) {
            this.$message.error(res1.msg)
            }
          })
         } else {
           this.$message.error('请求超时,请重新获取')
         }



      })

    },
    refreshUser(){
      this.getuserDetails()

    },
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    },
  // 查询账户信息
    getuserDetails() {
      this.loading = true;
      // if(this.userInfo.mallUser){
      //   console.log('xxxxxxx')
      //   return
      // }
      const req ={
        userId:this.userInfo.mallUser.muid,
      }
       //调个人中心接口
      userDetails(req)
        .then((res) => {
          if(res.code == 0){
            this.loading = false
            this.ruleForm={
                name: res.data.username,
                nickname: res.data.nickname,
                avatar: res.data.avatar,
                date:  res.data.birthday,
                gender: Number(res.data.sex)==1?'女':'男',
                sign: res.data.signature,
            }
            this.userInfo.userName = res.data.nickname
            this.userInfo.avatar = res.data.avatar
            this.urlImg = res.data.avatar
            this.likeGoods = res.data.like_Goods
            this.likeShop = res.data.like_store
            this.level = res.data.level
          }
        })
        .catch((err) => {
          this.$message.error("查询我的信息失败，请稍后再试！");
        });
    },
    // // 购物车查询
    // getshoppingCartlist() {
    //   this.accountTotal =0
    //    this.loading = true
    //   shoppingCartlist({uid:this.userInfo.mallUser.muid||''})
    //     .then((res) => {
    //      if(res.length>0){
    //         this.loading = false
    //      let newList= []
    //       res.forEach((x)=>{
    //           x.bxunyouMerchant.goods.forEach((y)=>{
    //             newList.push(y)
    //           })
    //       })
    //         this.list = newList;
    //         let sum = this.list.reduce((sum, item) => {
    //                   return sum + item.realprice * item.number; // 隐式转换
    //               }, 0);
    //               this.accountTotal += sum;
    //      }
    //         })
    //     .catch((err) => {
    //       // this.$message.error("查询购物车失败，请稍后再试！");
    //     });
    // },

    // 打开侧边的购物车
    openCartDrawer() {
      if (this.userInfo.mallUser.muid == undefined) {
        this.$message.error("请登录！");
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
        return;
      }
      this.addDialogVisible = true;
      this.$router.push('/shoppingcart')
      // this.$message({
      //     type: "success",
      //     duration:5000,
      //     message: "尊敬的用户您好：平台暂不支持在线支付，若您有任何订单需求可直接联系商家或平台，我们将竭诚为您提供服务。",
      //   });
      //20220107暂时注销购物车弹窗开始
      // this.drawer = true;
      // console.log("ji你来了吗", this.drawer);
      // this.footerdrawer = false;
      //20220107暂时注销购物车弹窗结束

      // this.getshoppingCartlist()
    },
// 打开询价篮
openInquiry() {
      if (this.userInfo.mallUser.muid == undefined) {
        this.$message.error("请登录！");
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
        return;
      }
      this.$router.push('/inquiryBasket')
    },
    // 查询我的足迹
    getfootList() {
      this.loading = true;
      footprint_list({ uid: this.userInfo.mallUser.muid })
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.footerlist = res.rows;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("我的足迹查询失败，请稍后再试！");
        });
    },

    // 打开侧边的我的足迹
    openFooterDrawer() {
      this.footerdrawer = true;
      this.drawer = false;
      // this.footerlist = this.list
      this.getfootList();
    },
    // handleClose(done) {
    //     this.$confirm('确认关闭？')
    //       .then(_ => {
    //         done();
    //       })
    //       .catch(_ => {});
    //   }
  },
  // beforeRouteEnter: (to, from, next) => {

  //   const matched = from
  //   console.log(matched,123123123123123)
  //   if(to.query.token){
  //     // to.matched[0].instances.default.getUniteUserInfo(to.query.token)
  //     next()
  //   }
  //   else{
  //     next()
  //   }
  // },
};
</script>
<style lang="less" scoped>
.dialogIMBox /deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 9px 0px 0px;
  height: 445px;
}

.dialogIMBox /deep/.el-dialog--center {
  text-align: center;
  position: absolute;
  right: 50px;
  bottom: 0px;
}

div#content-main-1 {
  height: inherit;
}

.el-header {
  padding: 0 0px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
/*
布局后续删除start
 */
.el-header,
.el-footer {
  /* background-color: #b3c0d1; */
  color: #333;
  text-align: center;
  /* line-height: 60px; */
  height: auto !important;
  padding: 0 0px;
}
.el-footer{
  background-color: #1A1A1C
}
.el-main {
  background-color: #F0F2F5;
  color: #333;
  /* text-align: center; */
  /* line-height: 160px; */
  padding: 0px;
  width: 100%;
  margin: auto;
  overflow: inherit;
}
/*
布局后续删除end
 */

.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #333;
}

.userNameBox {
  .el-image.userNameImg {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 1px solid #dadada;
  }
  .userNameBoxText.el-col.el-col-14 {
    position: relative;
    transform: translate(0, 50%);
    line-height: 30px;
    font-size: 16px;
  }
}
.userNameBoxBottom.el-col.el-col-12 {
  text-align: center;
  margin-bottom: 10px;
  a {
    display: inline-block;
    padding: 5px 20px;
    background: #f7f7f7;
    border: 1px solid #cecece;
    border-radius: 4px;
  }
}
.fixedRightNav {
  .rightNav {
    width: 40px;
    // box-shadow: 5px 5px 5px 4px #909399;
    // height: 242px;
    position: fixed;
    bottom: 0;
    right: 0;
    color: #333;
    box-sizing: border-box;
    text-align: center;
    z-index: 1000;
    .ai_agent_icon{
      cursor: pointer;
      width: 100px;
      height: 180px;
      position: absolute;
      right: -10px;
      top: -180px;
    }
    .rightButton{
      height: 45px;
      background-color: #237AE4;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .backTop{
      margin-bottom: 20px;
    }
    .el-button {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: transparent;
      border: 0px solid transparent;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      -webkit-transition: 0.1s;
      transition: 0.1s;
      font-weight: 500;
      padding: 0;
      font-size: 14px;
      border-radius: 0px;
      width: 100%;
    }
    p.el-icon-user {
      font-size: 26px;
      display: block;
      padding: 0.5rem 0;
      &::before{
        color: #333333;
      }
      span{
        display: block;
        font-size: 14px;
        color: #333333;
        margin-top: -0.8rem;
      }
    }
    p.el-icon-user:hover {
      background: rgba(0,0,0,0.1);
      cursor: pointer;
    }
    // .shoppingCart:hover {
    //   background: rgba(0,0,0,0.1);
    //   cursor: pointer;
    // }
    .shoppingCart {
      position: relative;
      i.shopping-cart-num{
        position: absolute;
        width: 18px;
        height: 18px;
        background: #EA675D;
        border-radius: 18px;
        color: #fff;
        line-height: 18px;
        top: 1px;
        right: 1px;
      }
      i.el-icon-shopping-cart-2 {
        font-size: 24px;
        color: #333;
      }
      img.inquiryColumn{
        display: block;
        width: 24px;
        height: 24px;
        margin: 3px auto;
      }
  i.el-icon-upload2{
    font-size: 24px;
        color: #333;
  }
      p,
      .cartNum {
        font-size: 14px;
        padding: 0 10px;
        color: #333;
        span {
          display: inline-block;
          width: 24px;
          background: #2178d2;
          border-radius: 10px;
        }
      }
    }
    .el-icon-view {
      font-size: 25px;
      display: block;
      height: 40px;
      line-height: 40px;
      color: #d9dada;
    }
    .el-icon-view:hover {
      background: #2178d2;
      cursor: pointer;
    }
    .nolike {
      width: 100%;
      height: auto;
      margin: 6px 0;
      padding: 8px 0;
      img {
        width: 70%;
      }
    }
    .nolike:hover {
      background: #2178d2;
      cursor: pointer;
    }
    .userPart {
      // bottom: 50px;
      // position: absolute;
      // padding: 4px;
      // left: 0px;
      .el-image {
        // border-radius: 50%;
        // width: 30px;
        // height: 30px;
        i.el-icon-user {
          width: 30px;
          height: 30px;
          font-size: 24px;
        }
      }
    }

    // 回到顶部
    .el-backtop {
      background: transparent;
      color: white;
      flex-direction: column;
      padding: 0.5rem 0;
      position: relative;
      width: auto;
      height: auto;
      border-radius: 0;
      box-shadow:none;
      i.el-icon-upload2 {
        font-size: 25px;
        &::before{
          color: #333;
        }
      }
      p{
        color: #333;
        font-size: 14px;
      }
    }
    .el-backtop:hover {
      background: rgba(0,0,0,0.1);
      border-radius: 0;
    }
  }
  .drawerCart {
    /deep/ :focus {
      outline: 0;
    }
    /deep/.el-drawer.rtl {
      // padding-right: 50px;
      padding-left: 20px;
      background: #eceaea;
      overflow: auto;
      /deep/.el-drawer__header {
        padding: 15px 0px;
        margin-bottom: 0;
      }
    }
    .drawerCartTitle {
      font-size: 17px;
      color: #5e5050;
      i.el-icon-shopping-cart-2 {
        font-size: 22px;
        vertical-align: middle;
      }
    }
    .drawerCartItem {
      height: 900px;
      // overflow: auto;
      padding-bottom: 50px;
      .drawerCartItem_no {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        .gotoShopText {
          color: #2178d2;
        }
      }
    }
    .drawerFooterItem {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .isdrawerFooterItem {
        .isdrawerFooterItemBg {
          background: white;
          padding: 8px;
          box-sizing: border-box;
          border-radius: 6px;
          margin-bottom: 15px;
          margin-right: 15px;
          .goodsFooter {
            width: 120px;
            height: 120px;
            background: #f5f5f5;
            cursor: pointer;
            position: relative;
            /deep/.image-slot {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .cartHeight {
            text-align: center;
            font-size: 16px;
          }
        }
      }
    }

    /* 购物车的样式 */
    .cartTip {
      .cartBox.el-row {
        margin: 15px;
        background: white;
        width: 100%;
        padding: 10px;
        .el-image.cartgoodsPhotos {
          height: 80px;
          width: 100%;
          position: inherit;
          cursor: pointer;
        }
        .cartHeight {
          height: 80px;
          line-height: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      .cartHeight_total {
        font-size: 18px;
        padding: 0 20px;
        color: #2178d2;
        .totalNum {
          font-size: 14px;
          color: #000;
        }
      }
      .cartHeight_cart {
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #2178d2;
        color: white;
        font-size: 15px;
        a.router-link-exact-active.router-link-active {
          color: white;
        }
      }
    }
  }
}
.userPartPop {
  display: flex;
  justify-content: space-evenly;
  /deep/.el-image.userPartPop_img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    i.el-icon-user {
      font-size: 30px;
    }
  }
  /deep/.userPartPop_text {
    line-height: 40px;
  }
}
/deep/.el-popover.el-popper.nolikePopBox {
  background: #5b5f67;
  color: white;
}


  /deep/.image-slotmsg{
  // position: relative;
  //   border-radius: 0;
  //   background: rgba(0,0,0,0);
  //   flex-direction: column;
  //   padding: .5rem 0;
  //   &:hover{
  //     background: rgba(0,0,0,0.1);
  //   }
  .el-icon-user::before{
  content:'';
  background: url(https://zhengtaiproductfile.oss-cn-hangzhou.aliyuncs.com/pcImages/ztimg/msg.png);
  background-size: 100% auto;
  width: 30px;
  height: 30px;
  display: block;
  margin: auto;
}

}

.interlayer{
  height: 1px;
  background: #fff;
  opacity: 0.8;
  width: 40px;
  margin: auto;
}

/dee/.el-container{
  background: #F0F2F5;
}
/deep/.el-drawer__header{
  margin-bottom: 12px;
  padding: 10px 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue